import {ReactNode} from 'react'
import {CILFPromoBanner} from '../../modules/surveys/components/CILFPromoBanner'
import {useLocation} from 'react-router-dom'

type Props = {
  children?: ReactNode
}

export function TradeShowLayout({children}: Props) {
  const {pathname} = useLocation()
  const CILFFormPage = pathname.includes('/CILF2025')

  return (
    <>
      <section className='tradeshow-layout bg-primary vh-100'>
        {CILFFormPage && <CILFPromoBanner />}
        <div
          className='container h-100 d-flex flex-column justify-content-center align-items-center'
          style={{maxWidth: '570px'}}
        >
          {children}
        </div>
      </section>
    </>
  )
}
